import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSearchFormPopularQueries',
  props: {
  items: {
    type: Array,
    default: () => [],
  },
},
  emits: ['input'],
  setup(__props, { emit }) {





const selectItem = (item: string) => {
  emit('input', item);
};

return { __sfc: true,emit, selectItem }
}

})